import { Component, Input } from '@angular/core';

@Component({
  selector: 'atlas-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  standalone: false,
})
export class TabComponent {
  @Input() label: string;
}
